export function freezeState(state: CoreState): CoreState {
  return {...state};
}
